import { render, staticRenderFns } from "./SignaturesComments.vue?vue&type=template&id=e25e5e64"
import script from "./SignaturesComments.vue?vue&type=script&lang=js"
export * from "./SignaturesComments.vue?vue&type=script&lang=js"
import style0 from "./SignaturesComments.vue?vue&type=style&index=0&id=e25e5e64&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports